import { ImageIcon, ScanText } from "lucide-react";
import { cn } from "@/lib/utils";

type SelectionActivationCueProps = {
  mode: "text" | "visual";
  compact?: boolean;
};

export function SelectionActivationCue({ mode, compact = false }: SelectionActivationCueProps) {
  const Icon = mode === "visual" ? ImageIcon : ScanText;
  const copy =
    mode === "visual"
      ? "Draw around a chart or diagram to add it to this chat."
      : "Select text in the PDF to add it to this chat.";

  return (
    <div
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border border-blue-100/85 bg-[linear-gradient(180deg,rgba(239,246,255,0.94),rgba(219,234,254,0.76))] px-2.5 py-1 text-[10px] font-medium text-blue-700 shadow-[0_10px_24px_rgba(59,130,246,0.12)]",
        compact && "px-2 py-0.5 text-[9px] shadow-none",
      )}
    >
      <Icon className={cn("shrink-0", compact ? "h-3 w-3" : "h-3.5 w-3.5")} />
      <span>{copy}</span>
    </div>
  );
}
